module.exports = __webpack_public_path__ + "static/img/chuangxingushi.d615fed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chuangxingushi.png
// module id = Zwkl
// module chunks = 1